import EventEmmiter from 'eventemitter3';
const emitter = new EventEmmiter();
const toastEmitter = (args, event = 'TOASTER') => emitter.emit(event, args);
export const EE = emitter;
export default toastEmitter;
